import styled from '../../../theme'

export default styled.span`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`
